import { Feature } from '@/enums/feature';
import type { OrganizationEmployee, OrganizationEmployeeProperties } from '@/types/employee';
import type { Module } from '@/types/module';
import type { Mutation } from '@/types/mutation';

export enum TypeOfOrganization {
    COMPANY = 'Bedrijf',
    BRANCH = 'Vestiging'
}

export type Organization = Mutation & {
    _id: string;
    type: TypeOfOrganization;
    name: string;
    maxUploadSizeMb: number;
    currentUploadSizeMb: number;
    /** OrganizationEmployee when populated, else OrganizationEmployeeProperties */
    employees: OrganizationEmployee[] | OrganizationEmployeeProperties[];
    parent: string | null;
    color: string;
    modules: Module['_id'][];
    features?: Feature[];
};

export type AccessibleOrganization = Organization & { children?: AccessibleOrganization[] };

export type OrganizationForm = {
    _id?: string;
    type?: TypeOfOrganization;
    name: string;
    maxUploadSizeMb?: number | null;
    currentUploadSizeMb?: number | null;
    parent?: string | null;
    modules?: Module['_id'][];
    features?: Feature[];
};

export interface OrganizationParent {
    _id: string;
    parents: Organization[];
}
